// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"PaymentCart_fadeIn__2ZWS3","fadeInAnimation":"PaymentCart_fadeInAnimation__1zGqm","carouselDiv":"PaymentCart_carouselDiv__24iLl"};